<footer>
  <div class="container-fluid">
    <div class="inner-container">
      <a class="navbar-brand" routerLink="/"
        ><img
          class="logo"
          src="/assets/img/logos/503B_Color.svg"
          alt="503B Logo"
      /></a>
      <p class="white">Copyright © {{ this.copyrightYear }} 503B.com LLC</p>
    </div>
  </div>
</footer>
